import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { NotificationService } from '../services';
import { NOTIFICATION_USER_KEY } from '../constants/query';
import { INotification } from '../interfaces/INotification';

interface UseUserNotificationsConfig {
  page?: number;
  size?: number;
  enabled?: boolean;
}

interface UseUserNotificationsReturn {
  notifications: INotification[];
  isLoading: boolean;
  isError: boolean;
  error: any;
  refetch: () => void;
}

export const useUserNotifications = (
  config?: UseUserNotificationsConfig,
): UseUserNotificationsReturn => {
  const { page = 0, size = 50, enabled = true } = config || {};

  const { data, isLoading, isError, error, refetch } = useQuery({
    // @ts-ignore
    queryKey: [NOTIFICATION_USER_KEY, page, size],
    queryFn: () =>
      NotificationService.getUserNotifications({
        page,
        size,
        sort: { createdAt: -1 },
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const notifications = useMemo(() => {
    return data?.data || [];
  }, [data]);

  return {
    notifications,
    isLoading,
    isError,
    error,
    refetch,
  };
};
